import "react-app-polyfill/ie11"; // ie11 support
import "react-app-polyfill/stable"; // ie11 support

import React from "react";
import ReactDOM from "react-dom/client"; // Import correct pour React 18+
import { makeMainRoutes } from "./routes";

const routes = makeMainRoutes();

// Utilisation de createRoot pour React 18+
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(routes);
